import axios from 'axios';

const DEFAULT_RAILWAY_API = 'https://site-consultoria-production.up.railway.app';

/**
 * Em dev, o padrão é a API na Railway (mesmo Postgres KingHost; IP residencial não precisa estar liberado).
 * Para testar o Express local: VITE_API_URL=http://localhost:3002 no .env.development.
 */
export function getApiBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_API_URL;
  if (typeof fromEnv === 'string' && fromEnv.trim() !== '') {
    return fromEnv.trim().replace(/\/$/, '');
  }
  return DEFAULT_RAILWAY_API;
}

const API_URL = getApiBaseUrl();

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
);

export interface ContactForm {
  name: string;
  email: string;
  phone: string;
  company: string;
  message: string;
}

export interface BlogPost {
  id: number;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  author: string;
  category: string;
  image_url: string;
  published: boolean;
  created_at: string;
  updated_at: string;
}

export const submitContact = async (data: ContactForm) => {
  const response = await api.post('/api/contact', data);
  return response.data;
};

export const getBlogPosts = async (): Promise<BlogPost[]> => {
  try {
    const response = await api.get('/api/blog/posts');
    return response.data.data || [];
  } catch {
    return [];
  }
};

export const getBlogPost = async (slug: string): Promise<BlogPost | null> => {
  try {
    const response = await api.get(`/api/blog/posts/${slug}`);
    return response.data.data || null;
  } catch {
    return null;
  }
};

export async function subscribeNewsletter(email: string, name?: string): Promise<void> {
  const response = await api.post('/api/newsletter/subscribe', { email, name });
  if (!response.data.success) {
    throw new Error(response.data.message || 'Erro ao se inscrever na newsletter');
  }
}

export async function searchBlogPosts(query: string): Promise<BlogPost[]> {
  try {
    const response = await api.get(`/api/blog/posts/search?q=${encodeURIComponent(query)}`);
    return response.data.data || [];
  } catch {
    return [];
  }
}

export async function getBlogPostsByCategory(category: string): Promise<BlogPost[]> {
  try {
    const response = await api.get(`/api/blog/posts/category/${encodeURIComponent(category)}`);
    return response.data.data || [];
  } catch {
    return [];
  }
}
